'use strict';

module.exports = function (url) {
    var header = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var data = arguments[2];
    var callback = arguments[3];

    if (!url) return;
    typeof callback == 'function' || (callback = noop);

    var xhr = new XMLHttpRequest();

    xhr.open('POST', url);
    if (typeof xhr.setRequestHeader == 'function' && header.length) {
        header.map(function (item) {
            xhr.setRequestHeader(item.name, item.value);
        });
    } else {}
    xhr.send(JSON.stringify(data));
    _addListener(xhr, 'loadend', callback); // FIXME: 结果由业务处理，组件只保证触发回调
};

function noop() {}

function _addListener(target, event, callback) {
    if (target && event) {
        if (addEventListener) {
            target.addEventListener(event, function (e) {
                typeof callback == 'function' && callback(e);
            });
        } else if (attachEvent) {
            // 兼容IE
            target.attachEvent('on' + event, function (e) {
                typeof callback == 'function' && callback(e);
            });
        } else {}
    }
}


//////////////////
// WEBPACK FOOTER
// ./~/@dp/whereami/lib/xhr2.js
// module id = 496
// module chunks = 1 12 14